import {useEffect, useRef, useState} from "react";

export default function SelectMulti(props) {
    const [data, setData] = useState([]);
    const [index, setIndex] = useState(-1);
    const [prevIndex, setPrevIndex] = useState(null);
    const optionsRef = useRef(null);
    const searchRef = useRef(null);

    useEffect(() => {
        setData(props.data.filter(o => ! props.chosen.includes(o.value)));
    }, [props.chosen])

    useEffect(() => {
       setData(props.data);
    }, [props.data])

    let chosen = props.chosen.map((item, index) =>
        <li key={index} className='chosen'><span>{getName(item)}</span><span ival={item} className='close-chosen-button' onClick={props.delHandler}>x</span></li>
    )

    let options = data?.map((item, index) =>
        ! props.chosen.includes(item.value) &&
        <li
            key={index}
            idx={index}
            className='select-multi-option'
            onClick={choiceHandler}
            onMouseOver={overHandler}
        >
            {item.name}
        </li>
    )

    useEffect(() => {
        window.addEventListener('click', closeSelect)

        return () => {
            window.removeEventListener('click', closeSelect)
        }
    }, []);

    function closeSelect(e) {
        if (document.getElementById(props.id).contains(e.target) && ! e.target.classList.contains('select-multi-option')) {
            setIndex(-1);
            setPrevIndex(null);
            optionsRef.current.style.display = 'block';
        } else optionsRef.current.style.display = 'none';
    }

    function getName(val) {
        let obj = props.data.find(o => o.value === val);
        return obj.name;
    }

    function choiceHandler() {
        let e = {target: {
                name: props.name,
                value: data[index].value
            }}
        optionsRef.current.style.display = 'none';
        setIndex(-1);
        setPrevIndex(null);
        searchRef.current.value = '';
        setData(props.data);
        props.handler(e)
    }

    useEffect(() => {
        let ul = optionsRef.current;
        let liList = ul.querySelectorAll('li');

        if (liList && liList.length > 0) {
            let curLi = liList[index];

            if (prevIndex && index > prevIndex) {
                curLi.classList.add('autocomplete-hover');
                if (index > 0) liList[prevIndex].classList.remove('autocomplete-hover');

                if ((curLi.offsetTop + curLi.offsetHeight - ul.scrollTop) >= ul.clientHeight) {
                    ul.scrollBy(0, curLi.offsetHeight);
                }
            } else if (prevIndex && index < prevIndex) {
                curLi.classList.add('autocomplete-hover');
                if (index >= 0) liList[prevIndex].classList.remove('autocomplete-hover');

                if ((curLi.offsetTop - ul.scrollTop) < 0) {
                    ul.scrollBy(0, -curLi.offsetHeight);
                }
            } else {
                liList.forEach((li) => {
                    li.classList.remove('autocomplete-hover');
                })
                if (curLi) curLi.classList.add('autocomplete-hover');
            }
        }
    }, [index])

    function keyDownHandler(e) {
        if (e.key === 'ArrowDown') {
            if (index < (props.data.length - 1)) {
                setPrevIndex(index);
                setIndex(index + 1);
            }
        } else if (e.key === 'ArrowUp') {
            if (index > 0) {
                setPrevIndex(index);
                setIndex(index - 1);
            }
        } else if (e.key === 'Enter') {
            choiceHandler();
        }
    }

    function overHandler(e) {
        setPrevIndex(null);
        setIndex(Number(e.target.getAttribute('idx')));
    }

    function searchHandler(e) {
        optionsRef.current.style.display = 'block';
        let newData = props.data.filter(item => item.name.toLowerCase().includes(e.target.value.toLowerCase()));
        setData(newData)
    }

    return (
        <div className={"textOnInput" + " " + props.class} id={props.id}>
            {props.label &&
                <label htmlFor={props.id}>{props.label}</label>
            }
            <div className='select-multi-wrap'>
                <ul className='select-field form-control'>
                    {chosen}
                    <li className='search-field'>
                        <input
                            type='text'
                            placeholder='Выбирайте несколько значений'
                            onKeyDown={keyDownHandler}
                            onChange={searchHandler}
                            ref={searchRef}
                        />
                    </li>
                </ul>
                <ul className='select-multi-options' ref={optionsRef}>
                    {options}
                </ul>
            </div>
        </div>
    )
}